import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyIcon } from '../../../../assets/images/icons/empty.svg';

function CancelledTab() {
  const { t } = useTranslation('wishlist');

  return(
    <div className="text-center mt-4">
      <EmptyIcon />

      <h6 className="mt-4 fw-normal text-muted">{t("empty")}</h6>
    </div>
  );
}

export default CancelledTab;